import { Provider } from '@angular/core';

import { CancelJobShiftsService } from '../Domain/Port/CancelJobShifts/cancel-job-shifts.service';
import { BackendCancelJobShiftsService } from '../Infrastructure/Adapter/CancelJobShifts/backend-cancel-job-shifts.service';

/**
 * Provides the CancelJobShiftsService for dependency injection.
 * 
 * This function configures Angular's dependency injection system to use
 * BackendCancelJobShiftsService as the implementation of CancelJobShiftsService.
 * This allows components and services to depend on the abstract CancelJobShiftsService
 * without knowing the concrete implementation.
 * 
 * @returns An array of providers for the CancelJobShiftsService
 */
export const cancelJobShiftsProvider = (): Provider[] => {
    return [
        {
            provide: CancelJobShiftsService,
            useExisting: BackendCancelJobShiftsService
        }
    ];
};
